import PropTypes from 'prop-types';

const WeeksConversionLeadTimeLabel = ({ leadTimeDays, roundToNearestWeek }) => {
  const remainderInDays = leadTimeDays % 5;
  if (roundToNearestWeek) {
    const numberInWeeks = remainderInDays >= 4 ? Math.ceil(leadTimeDays / 5) : Math.floor(leadTimeDays / 5);
    return `${numberInWeeks} ${(numberInWeeks > 1 || numberInWeeks === 0) ? 'weeks' : 'week'}`;
  } else {
    const numberInWeeks = Math.floor(leadTimeDays / 5);
    return `${numberInWeeks} ${(numberInWeeks > 1 || numberInWeeks === 0) ? 'weeks' : 'week'}${remainderInDays > 0 ? ` ${remainderInDays} ${remainderInDays > 1 ? 'days' : 'day'}` : ''}`;
  }
};

WeeksConversionLeadTimeLabel.propTypes = {
  leadTimeDays: PropTypes.number.isRequired,
  roundToNearestWeek: PropTypes.bool.isRequired,
};

WeeksConversionLeadTimeLabel.defaultProps = {
  roundToNearestWeek: false,
};

export default WeeksConversionLeadTimeLabel;
